import type { ModuleManifest } from "./manifest-registry";
import type { SlotDefinition } from "./slot-definition.type";

/** The host modules a module adds things to, from the slots it contributes to (what the store shows as "extends"). */
export function extendedModules(manifest: ModuleManifest, slots: readonly SlotDefinition[]): string[] {
  const hosts = manifest.contributes.map((c) => slots.find((s) => s.id === c.slot)?.host).filter((h): h is string => Boolean(h));
  return [...new Set(hosts)];
}
